<template>
  <div class="footer">
    <div class="footer-box">
      <div class="logo-box">
        <img src="../assets/logo-1.png" class="logo-1" />
        <div class="text">
          我們相信我們的品牌，我們相信Superior Always Limited的專業力量！
        </div>
      </div>
      <div class="connect">
        <div class="title">
          聯絡我們
        </div>
        <p><img src="../assets/tel.png" alt="" /> 00852+32254138</p>
        <p><img src="../assets/email.png" alt="" /> Jason@superioralwayslimited.com</p>
        <p>
          <img src="../assets/address.png" alt="" /> 
          UNIT2223, 22/F, YAN'S TOWER 25- 27 WONG CHUK HANG ROAD ABERDEEN HONG KONG
        </p>
      </div>
      <div class="menu-box">
        <div class="title">
          快速連結
        </div>
        <p @click="selectMenu(1)">> 首頁</p>
        <p @click="selectMenu(3)">> 關於我們</p>
        <p @click="selectMenu(5)">> 聯絡我們</p>
      </div>
    </div>
    <!-- <div class="copyright">
            © WAVETECMOBI LIMITED
        </div> -->
  </div>
</template>
<style lang="less" scoped>
.footer {
  .footer-box {
    height: 240px;
    background: #404040;
    padding: 120px 360px 106px 360px;
    display: flex;
    justify-content: space-between;
    .logo-box {
      width: 302px;
      font-size: 20px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #ffffff;
      .logo-1 {
        width: 250px;
        height: 30px;
      }
      .text {
        margin-top: 35px;
      }
    }
    .menu-box {
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      height: 200px;

      .title {
        font-size: 24px;
        font-family: Roboto-Black, Roboto;
        font-weight: 900;
        color: #ffffff;
      }
      p {
        cursor: pointer;
      }
    }
    .connect {
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
      width: 400px;
      height: 200px;
      display: flex;
      flex-direction: column;
      // align-items: center;
      justify-content: space-between;
      .title {
        font-size: 24px;
        font-family: Roboto-Black, Roboto;
        font-weight: 900;
        color: #ffffff;
        margin-bottom: 20px;
      }
      p {
        margin-bottom: 20px;
      }
      img {
        height: 20px;
      }
    }
    .customer {
      width: 120px;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .copyright {
    height: 64px;
    background: #2d2d2d;
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
    line-height: 64px;
    text-align: center;
  }
}
</style>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "business" });
          break;
        case 3:
          this.$router.push({ path: "us" });
          break;
        case 4:
          this.$router.push({ path: "offers" });
          break;
        case 5:
          this.$router.push({ path: "aboutUs" });
          break;
        // case 5: this.$router.push({ path: "cooperate" }); break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
